// extracted by mini-css-extract-plugin
module.exports = {"sideDrawer":"side-drawer_sideDrawer__2wUJD","open":"side-drawer_open__Wd2i8","closeX":"side-drawer_closeX__38pKj"};